import React, { useRef } from "react"
import {
  Modal,
  Typography,
  Space,
  Button,
  Alert,
  message,
} from "@mimber/ui-web"
import { useUnpublishDonationPage } from "@mimber/client/mimber-organization"
import type { UnpublishDonationPageModalProps } from "./UnpublishDonationPageModal.types"

const { Paragraph } = Typography

export const UnpublishDonationPageModal: React.FunctionComponent<
  UnpublishDonationPageModalProps
> = ({ donationPage, onSuccess, ...modalProps }) => {
  const closeRef = useRef<(() => void) | null>(null)

  const mutation = useUnpublishDonationPage(donationPage.uuid, {
    onSuccess: () => {
      message.success("Donation page unpublished")
      closeRef.current?.()
      onSuccess?.()
    },
    onError: (error) => {
      message.error(`Failed to unpublish donation page: ${error.message}`)
    },
  })

  return (
    <Modal title="Unpublish Donation Page" footer={null} {...modalProps}>
      {(close) => {
        closeRef.current = close
        return (
          <Space orientation="vertical" size="large" style={{ width: "100%" }}>
            <Alert
              type="warning"
              showIcon
              title="This donation page will stop accepting public donations"
              description="You can publish it again later at any time."
            />
            <Paragraph>
              Unpublish <strong>{donationPage.title}</strong> now?
            </Paragraph>
            <Space style={{ justifyContent: "flex-end", width: "100%" }}>
              <Button onClick={close} disabled={mutation.isPending}>
                Cancel
              </Button>
              <Button
                type="primary"
                danger
                loading={mutation.isPending}
                onClick={() => mutation.mutate()}
              >
                Unpublish Donation Page
              </Button>
            </Space>
          </Space>
        )
      }}
    </Modal>
  )
}
